import { render, staticRenderFns } from "./AnnouncementScheduleEditor.vue?vue&type=template&id=feb598bc&scoped=true"
import script from "./AnnouncementScheduleEditor.vue?vue&type=script&lang=js"
export * from "./AnnouncementScheduleEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb598bc",
  null
  
)

export default component.exports